import { render, staticRenderFns } from "./BusinessDocumentFlow.vue?vue&type=template&id=0dd848d9&scoped=true&"
import script from "./BusinessDocumentFlow.vue?vue&type=script&lang=js&"
export * from "./BusinessDocumentFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd848d9",
  null
  
)

export default component.exports